module.exports = __webpack_public_path__ + "drive.png";